import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Pills } from "@/components/OwnerFields";

export const KINDS = [["apartamento", "Apartamento"], ["moradia", "Moradia"], ["terreno", "Terreno"], ["loja", "Loja/Escritório"],
  ["garagem", "Garagem/Arrecadação"], ["predio", "Prédio"], ["outro", "Outro"]];
const TYPOLOGIES = ["T0", "T1", "T2", "T3", "T4", "T5+"].map((t) => [t, t]);
const Check = ({ v, on, label, tid }) => (
  <label className="inline-flex items-center gap-2 text-sm text-slate-600"><input type="checkbox" checked={!!v} onChange={(e) => on(e.target.checked)} data-testid={tid} />{label}</label>
);

export function PropertyFields({ k, setK }) {
  const set = (key, v) => setK({ ...k, [key]: v });
  const home = ["apartamento", "moradia"].includes(k.kind);
  return (
    <div className="space-y-3" data-testid="np-property-kind-block">
      <div><Label>Tipo de imóvel</Label><div className="mt-1.5"><Pills options={KINDS} value={k.kind} onChange={(v) => setK({ ...k, kind: v })} prefix="np-kind" /></div></div>
      {home && <div><Label>Tipologia</Label><div className="mt-1.5"><Pills options={TYPOLOGIES} value={k.typology} onChange={(v) => set("typology", v)} prefix="np-typology" /></div></div>}
      <div className="flex flex-wrap gap-x-6 gap-y-2">
        {k.kind === "moradia" && <Check v={k.condo} on={(v) => set("condo", v)} label="Tem condomínio" tid="np-has-condo" />}
        {home && <Check v={k.newBuild} on={(v) => set("newBuild", v)} label="Construção nova (licença pode estar em emissão)" tid="np-new-build" />}
        {["loja", "garagem"].includes(k.kind) && <Check v={k.fraction} on={(v) => set("fraction", v)} label="É uma fração (tem condomínio)" tid="np-is-fraction" />}
        {k.kind && !(k.kind === "terreno" && k.land === "rustico") && <Check v={k.omisso} on={(v) => set("omisso", v)} label="Prédio omisso / ainda sem inscrição (Modelo 1 entregue)" tid="np-omisso" />}
      </div>
      {k.kind === "terreno" && <div className="flex items-center gap-3"><Label>Rústico ou urbano?</Label><Pills options={[["rustico", "Rústico"], ["urbano", "Urbano"]]} value={k.land} onChange={(v) => set("land", v)} prefix="np-land" /></div>}
      {k.kind === "predio" && (
        <div className="space-y-2">
          <Pills options={[["total", "Propriedade total"], ["fracoes", "Em frações"]]} value={k.predio || "total"} onChange={(v) => set("predio", v)} prefix="np-predio" />
          {k.predio === "fracoes" && <div><Label>Frações à venda</Label><Input value={k.fracs || ""} onChange={(e) => set("fracs", e.target.value)} className="mt-1.5 max-w-md" placeholder="Ex.: A, B, C" data-testid="np-fractions" />
            <p className="text-xs text-slate-500 mt-1">Pedimos a caderneta e a certidão de cada fração indicada.</p></div>}
        </div>
      )}
    </div>
  );
}

export const propertyPayload = (k) => ({
  property_kind: k.kind || null,
  typology: ["apartamento", "moradia"].includes(k.kind) ? k.typology || null : null,
  has_condo: k.kind === "moradia" ? !!k.condo : null,
  is_fraction: k.kind === "apartamento" || (["loja", "garagem"].includes(k.kind) && !!k.fraction),
  new_build: !!k.newBuild,
  matrix_omisso: !!k.omisso && !(k.kind === "terreno" && k.land === "rustico"),
  land_type: k.kind === "terreno" ? k.land || null : null,
  predio_mode: k.kind === "predio" ? k.predio || "total" : null,
  fractions_for_sale: k.kind === "predio" && k.predio === "fracoes" ? (k.fracs || "").split(/[,;]/).map((x) => x.trim()).filter(Boolean) : [],
});
